import { combineReducers } from "redux";
import { Constant } from "../../Constant";
import approverEditFormTemp from "./approverEditFormTemp";
import attachment from "./attachment";
import clo from "./clo";
import form from "./form";
import formTemp from "./formTemp";
import iamsmart from "./iamsmart";
import isLoading from "./isLoading";
import isPopupOpen from "./isPopupOpen";
import profile from "./profile";

const isMobileNavOpen = (isMobileNavOpen = false, action) => {
    switch (action.type) {
        case Constant.action.TOGGLE_MOBILE_NAV:
            return !isMobileNavOpen;
        default:
            return isMobileNavOpen;
    }
};

const redirectUrl = (redirectUrl = "", action) => {
    switch (action.type) {
        case Constant.action.SET_REDIRECT_TO:
            return action.payload;
        case Constant.action.RESET_REDIRECT_TO:
            return "";
        default:
            return redirectUrl;
    }
};

const token = (token = "", action) => {
    switch (action.type) {
        case Constant.action.RESET_TOKEN:
            return "";
        case Constant.action.SET_TOKEN:
            return action.payload.token;
        default:
            return token;
    }
};

const userType = (userType = "", action) => {
    switch (action.type) {
        case Constant.action.RESET_USERTYPE:
            return "";
        case Constant.action.SET_USERTYPE:
            return action.payload.userType;
        default:
            return userType;
    }
};

const failRes = (failRes = {}, action) => {
    if (action.type.match(/.+_FAIL/)) {
        return action.payload;
    } else {
        return failRes;
    }
};

const userOrg = (userOrg = [], action) => {
    switch (action.type) {
        case Constant.action.SET_USER_ORG:
            return action.payload;
        case Constant.action.RESET_USER_ORG:
            return [];
        default:
            return userOrg;
    }
};

const selectedUserOrg = (selectedUserOrg = {}, action) => {
    const { type, payload } = action;
    switch (type) {
        case Constant.action.SET_SELECTED_USER_ORG:
            if (payload !== undefined) return payload;
            else return selectedUserOrg;
        case Constant.action.RESET_SELECTED_USER_ORG:
            return {};
        default:
            return selectedUserOrg;
    }
};

const currentWorkFlow = (currentWorkFlow = {}, action) => {
    const { type, payload } = action;
    switch (type) {
        case Constant.action.SET_CURRENT_WORKFLOW:
            if (payload !== undefined) return payload;
            else return currentWorkFlow;
        case Constant.action.RESET_CURRENT_WORKFLOW:
            return {};
        default:
            return currentWorkFlow;
    }
};

const searchData = (searchData = {}, action) => {
    const { type, payload } = action;
    switch (type) {
        case Constant.action.SET_SEARCH_DATA:
            if (payload !== undefined) return payload;
            else return searchData;
        case Constant.action.RESET_SEARCH_DATA:
            return {};
        default:
            return searchData;
    }
};

const applicantFormList = (applicantFormList = [], action) => {
    switch (action.type) {
        case Constant.action.SET_APPLICANT_FORM_LIST:
            return action.payload;
        case Constant.action.RESET_APPLICANT_FORM_LIST:
            return [];
        default:
            return applicantFormList;
    }
};

const formTitleParamList = (formTitleParamList = [], action) => {
    switch (action.type) {
        case Constant.action.SET_FORM_TITLE_PARAM_LIST:
            return action.payload;
        case Constant.action.RESET_FORM_TITLE_PARAM_LIST:
            return [];
        default:
            return formTitleParamList;
    }
};

const kindergartenCccName = (kindergartenCccName = [], action) => {
    switch (action.type) {
        case Constant.action.SET_KGCCC_SCRN:
            return action.payload;
        default:
            return kindergartenCccName;
    }
};

const schoolList = (schoolList = [], action) => {
    switch (action.type) {
        case Constant.action.SET_SCHOOL_LIST:
            return action.payload;
        default:
            return schoolList;
    }
};

const isMultiSubmitEditing = (isMultiSubmitEditing = true, action) => {
    switch (action.type) {
        case Constant.action.TOGGLE_MULTISUBMIT_EDITING:
            return action.payload;
        default:
            return isMultiSubmitEditing;
    }
};

const isExceedingDeadline = (isExceedingDeadline = false, action) => {
    switch (action.type) {
        case Constant.action.TOGGLE_ISEXCEEDING_DEADLINE:
            return action.payload;
        default:
            return isExceedingDeadline;
    }
};

const form101EffectiveJob = (form101EffectiveJob = [], action) => {
    switch (action.type) {
        case Constant.action.SET_EFFECTIVE_JOB:
            return action.payload;
        default:
            return form101EffectiveJob;
    }
};

const latestParameter = (latestParameter = {}, action) => {
    switch (action.type) {
        case Constant.action.GET_LATEST_PARAMS.DONE:
            return action.payload;
        default:
            return latestParameter;
    }
};

const serverTime = (serverTime = "", action) => {
    switch (action.type) {
        case Constant.action.SET_SERVERTIME:
            return action.payload;
        default:
            return serverTime;
    }
};

const isLoginDialogOpen = (isLoginDialogOpen = false, action) => {
    switch (action.type) {
        case Constant.action.TOGGLE_LOGIN_DIALOG:
            return action.payload;
        default:
            return isLoginDialogOpen;
    }
};

const allCollBoxGroupAuth = (allCollBoxGroupAuth = false, action) => {
    switch (action.type) {
        case Constant.action.SET_ALL_COLLBOX_GROUP_AUTH:
            return action.payload;
        default:
            return allCollBoxGroupAuth;
    }
};

const ssloResetPassWordTime = (ssloResetPassWordTime = null, action) => {
    switch (action.type) {
        case Constant.action.SET_SSLO_RESET_PASSWORD_TIME:
            return action.payload;
        default:
            return ssloResetPassWordTime;
    }
};

const publicResetPassWordTime = (publicResetPassWordTime = null, action) => {
    switch (action.type) {
        case Constant.action.SET_PUBLIC_RESET_PASSWORD_TIME:
            return action.payload;
        default:
            return publicResetPassWordTime;
    }
};

const reducer = combineReducers({
    form,
    formTemp,
    token,
    isMobileNavOpen,
    isPopupOpen,
    iamsmart,
    attachment,
    clo,
    profile,
    redirectUrl,
    isLoading,
    failRes,
    userOrg,
    selectedUserOrg,
    currentWorkFlow,
    searchData,
    applicantFormList,
    formTitleParamList,
    kindergartenCccName,
    schoolList,
    approverEditFormTemp,
    isMultiSubmitEditing,
    isExceedingDeadline,
    form101EffectiveJob,
    latestParameter,
    serverTime,
    isLoginDialogOpen,
    allCollBoxGroupAuth,
    ssloResetPassWordTime,
    publicResetPassWordTime,
});

export default reducer;
